export default {
  id: 164,
  title: 'Target #164 - Rangoli',
  url: 'https://cssbattle.dev/play/164',
  colors: ['#66284A', '#D86F45', '#F0CD48', '#D669EC', '#FDFBF8'],
  solution:
    '<a a><a b><a c><a d><style>[b],[c]{left:150}[a],[d]{top:100}body{background:#66284a}a{position:fixed;width:60;height:60;border:20px solid;transform:rotate(135deg);border-radius:9in}[a]{left:90;border-color:transparent #d86f45 #d86f45}[b]{top:40;border-color:#f0cd48 transparent #f0cd48 #f0cd48}[c]{top:160;border-color:#fdfbf8 #fdfbf8 #fdfbf8 transparent}[d]{left:210;border-color:#d669ec #d669ec transparent}</style>',
}
